import React from 'react';

type ComponentProps = {
	label: string;
	onClick?: () => void;
	type?: 'button' | 'submit' | 'reset';
	disabled?: boolean;
};

export default function Button({ label, onClick, type = 'button', disabled }: ComponentProps) {
	if (type === 'submit') {
		return (
			<button
				className="border-UC-blue-800 text-UC-blue-800 hover:text-UC-blue-700 hover:border-UC-blue-700 w-28 min-w-36 rounded border-2 bg-white py-1 font-serif text-2xl font-semibold transition-all duration-300 ease-in-out focus:outline-none"
				disabled={disabled}
				onClick={onClick}
				type="submit"
			>
				{disabled ? (
					<div className="flex w-full justify-center">
						<svg
							className="h-5 w-5 animate-spin text-black"
							fill="none"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle className="opacity-25" cx="12" cy="12" r="10" stroke="black" strokeWidth="4" />
							<path className="opacity-75" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" fill="black" />
						</svg>
					</div>
				) : (
					<div>{label}</div>
				)}
			</button>
		);
	} else if (type === 'reset') {
		return (
			<button
				className="border-UC-blue-800 text-UC-blue-800 hover:text-UC-blue-700 hover:border-UC-blue-700 w-28 min-w-36 rounded border-2 bg-white py-1 font-serif text-2xl font-semibold transition-all duration-300 ease-in-out focus:outline-none"
				onClick={onClick}
				type="reset"
			>
				{label}
			</button>
		);
	}
	return (
		<button
			className="border-UC-blue-800 text-UC-blue-800 hover:text-UC-blue-700 hover:border-UC-blue-700 w-28 min-w-36 rounded border-2 bg-white py-1 font-serif text-2xl font-semibold transition-all duration-300 ease-in-out focus:outline-none"
			disabled={disabled}
			onClick={onClick}
			type="button"
		>
			{label}
		</button>
	);
}
